import getActiveSheet from '@/spreadsheets/getActiveSheet'
import separateColumnSet from '@/utils/comparables/separateColumnSet'
import { INDUSTRY_GROUP_GICS_LABEL, ISSUE_TYPE_144A } from '@/utils/comparables/constants'

export default (
  compsType = 'company',
  {
    outliersIncluded,
    classificationSelected,
    fxSetting,
    issueType,
    sheetName,
    customColumnSet,
    sortInfo,
    filterItemMap,
  },
) => {
  const sheet = getActiveSheet()
  if (!sheet) {
    return
  }
  const { columns, columnConfig } = separateColumnSet(customColumnSet)
  const compsProps = {
    type: compsType,
    filterItemMap,
    sortInfo: sortInfo,
    columnConfig,
    columns,
    activeSheet: sheetName ?? getActiveSheet().name(),
    currency: fxSetting,
  }
  if (compsType === 'sector') {
    compsProps.gicsLevel = classificationSelected || INDUSTRY_GROUP_GICS_LABEL
    compsProps.outliersIncluded = outliersIncluded || false
    delete compsProps.activeSheet
  }
  if (['market', 'biggest-movers'].includes(compsType)) {
    compsProps.activeSheet = null
    compsProps.issueType = issueType || ISSUE_TYPE_144A
    delete compsProps.activeSheet
  }

  // console.timeEnd('serialize workbook')
  return compsProps
}
